import React, { useEffect } from 'react';

const APP_STORE_URL = 'https://apps.apple.com/us/app/inspecly/id6755496831';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.inspecly.mobile';

const detectStoreUrl = (): string | null => {
    const ua = navigator.userAgent || '';
    // iPadOS 13+ se présente comme un Mac, on le distingue via le tactile
    const isIOS = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
    if (isIOS) return APP_STORE_URL;
    if (/Android/i.test(ua)) return PLAY_STORE_URL;
    return null;
};

// Lien public inspecly.io/app : redirige vers le bon store selon l'appareil
const AppRedirect = () => {
    const storeUrl = detectStoreUrl();

    useEffect(() => {
        if (storeUrl) {
            window.location.replace(storeUrl);
        }
    }, [storeUrl]);

    if (storeUrl) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <p className="text-gray-600">Redirection vers le store...</p>
            </div>
        );
    }

    // Desktop : on propose les deux stores
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 text-center">
            <img src="/logo.png" alt="Inspecly" className="h-16 mb-6" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Téléchargez l'application Inspecly</h1>
            <p className="text-gray-600 mb-8">Disponible sur iPhone et Android</p>
            <div className="flex flex-col sm:flex-row gap-4">
                <a
                    href={APP_STORE_URL}
                    className="px-6 py-3 rounded-lg bg-black text-white font-medium hover:bg-gray-800"
                >
                    App Store
                </a>
                <a
                    href={PLAY_STORE_URL}
                    className="px-6 py-3 rounded-lg bg-black text-white font-medium hover:bg-gray-800"
                >
                    Google Play
                </a>
            </div>
        </div>
    );
};

export default AppRedirect;
